import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import './App.scss';
import OauthFailed from './components/login/OauthFailed';
import { useModal } from './components/modal/ModalContext';
import { useOauthHelper } from './helpers/login/oauthHelper';
import Layout from './Layout/Layout';
// import EventAnalytics from "./pages/admin/eventAnalytics/EventAnalytics";

export const AppProvider = () => {
  const [{ openModal }] = useModal();
  const oauthHelper = useOauthHelper();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const init = async () => {
      const oauthData = searchParams?.get('oauthData');
      const postLoginAction = searchParams?.get('action');
      const oauthError = searchParams?.get('error');

      if (oauthData) {
        try {
          await oauthHelper.getLoginCookies(oauthData);
        } catch (e) {}
      }

      if (oauthData || postLoginAction || oauthError) navigate(location?.pathname, true);

      if (oauthError)
        openModal({
          className: 'oauthFailed-container',
          content: <OauthFailed oauthError={oauthError} />,
        });
    };

    init().catch(e => {});
  }, []);

  return (
    <>
      <Outlet />
    </>
  );
};

const App = () => {
  // return <Mrep />;
  return <Layout />;
};

export default App;
